import { BehaviorSubject } from 'rxjs';
var dialog = new BehaviorSubject(null);
export function observeConfirmationDialog() {
    return dialog.asObservable();
}
export function showConfirmationDialog(confirmationDialog) {
    dialog.next(confirmationDialog);
}
export function closeConfirmationDialog() {
    dialog.next(null);
}
//# sourceMappingURL=ConfirmationDialogOperations.js.map